import {useTheme} from '@material-ui/core/styles';
import MuiAvatar from '@material-ui/core/Avatar';
import React from 'react';

export default React.memo(function Avatar({avatar, alt, size = 8}) {
  const theme = useTheme();
  const {
    thumbnail,
    color = theme.palette.gray.dark,
    initials = 'ن‌ش',
  } = avatar || {};

  const style = {
    width: theme.spacing(size),
    height: theme.spacing(size),
    backgroundColor: color,
  };

  return thumbnail ? (
    <MuiAvatar alt={alt || initials} src={thumbnail} style={style} />
  ) : (
    <MuiAvatar alt={alt || initials} style={style}>
      {initials}
    </MuiAvatar>
  );
});
